var notFound = {
    title: 'File not found',
    description: 'File was not found or it has been deleted',
    uploadFile: 'Upload file'
}

var message = {
    fileUploaded: 'File successfuly uploaded to server',
    fileDeleted: 'File successfuly deleted from server',
    fileAlreadyExist: 'File already exists on server',
    passwordInvalid: 'Password is not correct',
    somethingWentWrong: 'Something went wrong'
}

var validationMessage = {
    invalid: 'Field is invalid',
    valid: 'Field is valid',
    recaptcha_invalid: 'ReCaptcha is not validated'
}

var uploadForm = {
    label: {
        senderName: 'Sender name and surname',
        senderEmail: 'Sender email',
        otherEmails: 'Recipients',
        password: 'Password',
        addPassword: 'Protect by password',
        showPassword: 'Show password',
        confirmPassword: 'Confirm password',
        message: 'Message',
        addMessage: 'Add message for recipients',
        file: 'Select the file',
        dropFile: 'or drop the file'
    },
    validationMessage
}

var downloadForm = {
    label: {
        password: 'Password',
        name: 'Your name'
    },
    validationMessage
}

var deleteForm = {
    label: {
        password: 'Password',
    },
    validationMessage
}

var uploadView = {
    label: {
        title: 'Use DEFShare to ensure that the information you send does not fall into the wrong hands.',
        upload: 'Upload',
        uploading: 'Uploading ...',
        done: 'Done'
    },
    list: [
        'Defshare serves for secure transfer of big files between customer or external suppliers and ZAT a.s. company.',
        'Mandatory fields are: name, surname, sender email, list of receivers (for multiple receivers use comma or semicolon separator).',
        'For higher security it is recommended to use password (optional). Password is not part of auto-generated email message and it is necessary to send it separately!',
        'Maximum size of upload file is 4GB (for uploading larger file it is necessary to split it to parts).',
        'File expires in 30 calendar days. The file will be deleted after this period.'
    ],
    version: 'Version',
    login: 'Log In',
    message
}

var deleteView = {
    label: {
        name: 'File name',
        size: 'Size',
        delete: 'Delete',
        deleting: 'Deleting file ...',
        uploadFile: 'Upload file'
    },
    message
}

var downloadView = {
    label: {
        name: 'File name',
        size: 'Size',
        download: 'Download',
        downloading: 'Downloading ...',
        uploadFile: 'Upload file'
    },
    message
}

var notFoundView = {
    title: 'Page doesn\'t exist',
    description: 'This url doesn\'t exist on this site.',
    uploadFile: 'Upload file'
}

var login = {
    loginUnauthorized: 'Invalid login credentials',
    loginForbid: 'You don\'t have permission to access the file management',
    loginAuthorize: 'You need to log in to continue to file management',
    loginLogout: 'You have been successfully logged out',
    tokenExpire: 'You have been automatically logged out'
}

var notification = {
    success: "Success",
    error: "Error",
    info: "Information"
}

export default {
    uploadForm,
    downloadForm,
    deleteForm,
    uploadView,
    downloadView,
    notFoundView,
    deleteView,
    notification,
    notFound,
    validationMessage,
    login
}